import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./PublicHeader.css";
import "../../Authentication/AuthModal.css";
import LoginModal from "../../Authentication/LoginModal";
import RegisterModal from "../../Authentication/RegisterModal";
import { useAuth } from "../../Common/Configurations/AuthContext"; // 1. Import useAuth
import ForgotPasswordModal from "../../Authentication/ForgotPasswordModal";
import { FaBinoculars, FaBus, FaHotel, FaUmbrellaBeach, FaPlane } from "react-icons/fa6";

export default function PublicHeader(props) {
  const { user } = useAuth(); // 2. Get user object from context
  const { pathname } = useLocation();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

  const handleCloseModals = () => {
    setShowLoginModal(false);
    setShowRegisterModal(false);
    setShowForgotPasswordModal(false);
  };

  const handleShowLogin = () => {
    handleCloseModals();
    setShowLoginModal(true);
  };

  const handleSwitchToRegister = () => {
    setShowLoginModal(false);
    setShowRegisterModal(true);
  };
  const handleSwitchToForgotPassword = () => {
        setShowLoginModal(false);
        setShowRegisterModal(false);
        setShowForgotPasswordModal(true);
    };

  const handleSwitchToLogin = () => {
    setShowRegisterModal(false);
    setShowForgotPasswordModal(false);
    setShowLoginModal(true);
  };
    return (
        <>
            <div className="navbar-header">
                <div className="public-header-inner">
                    <Link className="public-header-brand" to="/" aria-label="Land Air home">
                        <img src="/assets/images/logo.png" alt="Land Air" />
                    </Link>
                    <nav className="public-header-nav" aria-label="Main navigation">
                        <NavLink className={({ isActive }) => `public-header-nav-link${isActive || pathname === "/" || pathname.startsWith("/flight/") ? " active" : ""}`} to="/flight/search">
                            <FaPlane aria-hidden="true" /><span>Flights</span>
                        </NavLink>
                        <NavLink className={({ isActive }) => `public-header-nav-link${isActive ? " active" : ""}`} to="/hotel/search">
                            <FaHotel aria-hidden="true" /><span>Hotels</span>
                        </NavLink>
                        <NavLink className={({ isActive }) => `public-header-nav-link${isActive ? " active" : ""}`} to="/holidays">
                            <FaUmbrellaBeach aria-hidden="true" /><span>Packages</span>
                        </NavLink>
                        <NavLink className={({ isActive }) => `public-header-nav-link${isActive ? " active" : ""}`} to="/search/sightseeing">
                            <FaBinoculars aria-hidden="true" /><span>Sightseeing</span>
                        </NavLink>
                        <NavLink className={({ isActive }) => `public-header-nav-link${isActive ? " active" : ""}`} to="/bus/search">
                            <FaBus aria-hidden="true" /><span>Bus</span>
                        </NavLink>
                    </nav>
                    <div className="public-header-actions">
                        {user ? (
                            <Link to="/my-profile" className="public-header-account">
                                <i className="ri-user-line" aria-hidden="true"></i><span>My account</span>
                            </Link>
                        ) : (
                            <Link onClick={handleShowLogin} className="public-header-account">
                                <i className="ri-user-line" aria-hidden="true"></i><span>Login</span>
                            </Link>
                        )}
                    </div>
                </div>
              
            </div>
            
          {!user && (
        <>
          <LoginModal
            show={showLoginModal}
            onClose={handleCloseModals}
            onSwitchToRegister={handleSwitchToRegister}
            onSwitchToForgotPassword={handleSwitchToForgotPassword}
          />
          <RegisterModal
            show={showRegisterModal}
            onClose={handleCloseModals}
            onSwitchToLogin={handleSwitchToLogin}
            onLoginSuccess={handleCloseModals}
          />
          <ForgotPasswordModal 
                show={showForgotPasswordModal}
                onClose={handleCloseModals}
                onSwitchToLogin={handleSwitchToLogin}
            />
        </>
      )}
      </>
  );
}
